export const StatusProject = ({status})=>{
console.log("kayak",status)
    return(
        <div className="flex flex-row justify-center h-fit my-4">
{status&&<ul className="steps steps-vertical lg:steps-horizontal scale-75 lg:scale-100 ">
  <li className={"step "+(status>=1&&" step-success")}>Stade de l'idée</li>
  <li className={"step "+((status>=2&&status<=5)&&" step-success")}>Stade de la rédaction du cahier des charges MVP</li>
  <li className={"step "+((status>=3&&status<=5)&&" step-success")}>Stade de la Réalisation MVP</li>
  <li className={"step "+((status>=4&&status<=5)&&" step-success")}>Stade de la rédaction du Cahier des charges V0</li>
  <li className={"step "+((status===5)&&" step-success")}>Stade de la Réalisation V0 et maintenance</li>
</ul>}

</div>
    )
}